import { Component, input } from '@angular/core';
import { Location } from '@angular/common';
import { LTButtonComponent } from '../lt-button/lt-button.component';
@Component({
  selector: 'app-lt-button-go-back',
  imports: [LTButtonComponent],
  template: `
    <app-lt-button
      [label]="label()"
      [color]="color()"
      [size]="size()"
      [disabled]="disabled()"
      [shape]="shape()"
      [classes]="classes()"
      [backgroundColor]="backgroundColor()"
      [textColor]="textColor()"
      (clicked)="goBack()"
    />
  `,
  standalone: true,
})
export class LTButtonGoBackComponent {
  label = input<string>('Go Back');
  
  color = input<string>('primary');
  size = input<'small' | 'medium' | ''>('');
  disabled = input<boolean>(false);
  shape = input<'' | 'square'>('');
  classes = input<string | null>();
  backgroundColor = input<string | null>(null);
  textColor = input<string | null>(null);

  constructor(private location: Location){}

  goBack(): void {
    this.location.back();
  }
}
